module.exports = __webpack_public_path__ + "img/taketomi_6.32463a11.jpg";